import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactStars from 'react-stars';

import { applications } from '../../Data/applications';
import { message } from '../../translate';
import './css/index.css';

const propTypes = {
  app_name : PropTypes.string.isRequired,
  cat_name : PropTypes.string.isRequired
}

class SoftaculousApp extends Component {

  constructor (props) {
    super(props);

    this.state = { info_app : [] }
  }

  componentDidMount () {
    let info_app = applications().filter( _apps => _apps.name === this.props.app_name )['0'];

    this.setState({ info_app });
  }

  render () {
    let { name, amount_stars, capture, description1, description2, desEng1, desEng2 } = this.state.info_app;
    let locale = localStorage.locale || 'es', des1 = "", des2 = "";

    if ( locale === 'es' ) {
      des1 = description1;
      des2 = description2;
    } else if ( locale === 'en-US' ) {
      des1 = desEng1;
      des2 = desEng2;
    }

    return (
      <div>
        <div className="position-relative overflow-hidden p-3 p-md-5 m-md-3 text-center bg-light">
          <div className="col-md-5 p-lg-5 mx-auto my-5">
            <h1 className="display-4 font-weight-normal">
              { name }
            </h1>
            <p className="lead font-weight-normal">
              { this.props.cat_name }
            </p>
            <br/>
            <div className="row justify-content-center align-items-center">
              <ReactStars
                size   = { 24 }
                color2 = { '#ffd700' }
                value  = { amount_stars }
                edit   = { false }
              />
            </div>
          </div>
          <div className="product-device box-shadow d-none d-md-block"></div>
          <div className="product-device product-device-2 box-shadow d-none d-md-block"></div>
        </div>

        <div className="d-md-flex flex-md-equal w-100 my-md-3 pl-md-3">
          <div className="bg-dark mr-md-3 pt-3 px-3 pt-md-5 px-md-5 text-center text-white overflow-hidden">
            <div className="my-3 py-3">
              <h2 className="display-5">{ message('capture_screen') }</h2>
              <p className="lead">
                <img src = { capture } alt = { name } className="img-thumbnail"  />
              </p>
            </div>
            <div className="bg-light box-shadow mx-auto boxStyle"></div>
          </div>
          <div className="bg-light mr-md-3 pt-3 px-3 pt-md-5 px-md-5 text-center overflow-hidden">
            <div className="my-3 p-3">
              <h2 className="display-5">{ message('description') }</h2>
              <p className="lead text-justify">
                { des1 }
              </p>
              <p className="lead text-justify">
              { des2 }
              </p>
            </div>
            <div className="bg-dark box-shadow mx-auto boxStyle"></div>
          </div>
        </div>

      </div>
    )
  }
}

SoftaculousApp.propTypes = propTypes;

export default SoftaculousApp;



// WEBPACK FOOTER //
// ./src/components/SoftaculousApp/index.js